export default "__VITE_ASSET__fR58Nu97__"